import { auth, db } from "../../../firebaseConfig"; // Make sure to import your Firebase configuration
import { doc, setDoc } from "firebase/firestore";
import { getSelectedUid } from "../../../../frontend/Recruitment/Applications/Utils/UidListener";

// Function to save form data for Section 2
export const writeDataS2 = async (formData) => {
  const userId = getSelectedUid(); // Get the selected UID
  if (!userId) {
    throw new Error("Invalid user.");
  }
  try {
    const docRef = doc(
      db,
      "Advisers",
      userId,
      "Application Details",
      "Professional Qualifications"
    );

    await setDoc(
      docRef,
      {
        ...formData,
      },
      { merge: true }
    );
    // console.log("Section 2 data successfully written to Firestore!");
  } catch (error) {
    // console.error("Error writing Section 2 data to Firestore: ", error);
  }
};
